import { paperTypeCollection } from "@/firebase";

const state = {
  paperType: {}
};

const getters = {};

const actions = {
  getPaperType({ commit }, payload) {
    paperTypeCollection
      .where("client", "==", payload)
      .orderBy("paperType", "asc")
      .get()
      .then(querySnapshot => {
        let tempData = [];
        querySnapshot.forEach(doc => {
          tempData.push(Object.assign(doc.data(), { id: doc.id }));
        });
        commit("getPaperType", tempData);
      });
  },
  addPaperType({ commit }, payload) {
    paperTypeCollection.add(payload).then(docRef => {
      commit("addPaperType", Object.assign(payload, { id: docRef.id }));
    });
  },
  removePaperType({ commit }, payload) {
    paperTypeCollection
      .doc(payload)
      .delete()
      .then(() => {
        commit("removePaperType", payload);
      });
  },
  editPaperType({ commit }, payload) {
    paperTypeCollection
      .doc(payload.id)
      .set(payload)
      .then(() => {
        commit("editPaperType", payload);
      });
  }
};

const mutations = {
  getPaperType(state, payload) {
    state.paperType = payload;
  },
  addPaperType(state, payload) {
    state.paperType.push(payload);
  },
  removePaperType(state, payload) {
    const index = state.paperType.findIndex(item => item.id == payload);
    state.paperType.splice(index, 1);
  },
  editPaperType(state, payload) {
    const index = state.paperType.findIndex(item => item.id == payload.id);
    state.paperType.splice(index, 1, payload);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
